import { Link } from "react-router-dom";

const company = {
  fullName: "T-NRG Kereskedelmi és Szolgáltató Korlátolt Felelősségű Társaság",
  shortName: "T-NRG Kft.",
  registeredSeat: "1083 Budapest, Práter utca 34.",
  officeAddress: "5000 Szolnok, Dózsa György utca 12/A, Hungary",
  registrationNumber: "01-09-344783",
  registeredCourt: "Fővárosi Törvényszék",
  vat: "24217664-2-42",
  euVat: "HU 24217664",
  contactEmail: "pvreport@t-nrg.com",
  privacyEmail: "admin@t-nrg.com",
  phone: "+36 30 558 9688",
};

const pages = {
  imprint: {
    title: "Imprint / Impresszum",
    updated: "Last updated / Utolsó frissítés: 2026-05-31",
    sections: [
      {
        heading: "Service provider information",
        body: [
          `Company name: ${company.fullName}`,
          `Short name: ${company.shortName}`,
          `Registered seat: ${company.registeredSeat}`,
          `Office and postal address: ${company.officeAddress}`,
          `Company registration number: ${company.registrationNumber}`,
          `Registering court: ${company.registeredCourt}`,
          `Hungarian VAT number: ${company.vat}`,
          `EU VAT number: ${company.euVat}`,
          `Email: ${company.contactEmail}`,
          `Phone: ${company.phone}`,
          "Hosting provider: T-NRG Kft. The website is hosted and operated on company-owned server infrastructure. Hosting contact: admin@t-nrg.com.",
        ],
      },
      {
        heading: "Szolgáltatói adatok",
        body: [
          `Cégnév: ${company.fullName}`,
          `Rövidített név: ${company.shortName}`,
          `Székhely: ${company.registeredSeat}`,
          `Irodai és postai cím: ${company.officeAddress}`,
          `Cégjegyzékszám: ${company.registrationNumber}`,
          `Nyilvántartó cégbíróság: ${company.registeredCourt}`,
          `Adószám: ${company.vat}`,
          `Közösségi adószám: ${company.euVat}`,
          `E-mail: ${company.contactEmail}`,
          `Telefon: ${company.phone}`,
          "Tárhelyszolgáltató: T-NRG Kft. A weboldal a társaság saját tulajdonú szerverinfrastruktúráján kerül üzemeltetésre. Tárhely üzemeltetési kapcsolattartó: admin@t-nrg.com.",
        ],
      },
    ],
  },
  privacy: {
    title: "Privacy Policy / Adatkezelési tájékoztató",
    updated: "Last updated / Utolsó frissítés: 2026-05-31",
    sections: [
      {
        heading: "Controller",
        body: [
          `The data controller is ${company.fullName} (${company.shortName}).`,
          `Registered seat: ${company.registeredSeat}`,
          `Privacy contact: ${company.privacyEmail}`,
          "No data protection officer has been appointed.",
        ],
      },
      {
        heading: "Public website processing",
        body: [
          "The public PV-REPORT landing page is operated to present the PV-REPORT platform and provide contact information for demo and business enquiries.",
          "The website may process technical server log data such as IP address, request time, requested URL, browser user agent, HTTP status code, and similar security and diagnostic information.",
          "The public landing page also uses self-hosted Umami analytics to understand aggregated visitor activity, page views, referrers, countries, devices, browsers, and demo request clicks. Umami is hosted by T-NRG Kft. on company infrastructure.",
          "The legal basis is the controller's legitimate interest in operating a secure and reliable website and protecting the service against abuse.",
        ],
      },
      {
        heading: "Contact by email or phone",
        body: [
          "If you contact T-NRG Kft. by email or phone, the company processes the personal data you provide, such as name, email address, phone number, company, message content, and related business communication.",
          "The legal basis is taking steps prior to entering into a contract, performance of a contract where applicable, or legitimate interest in responding to business enquiries.",
        ],
      },
      {
        heading: "Retention and recipients",
        body: [
          "Technical server logs are retained only as long as needed for security, diagnostics, and operational troubleshooting.",
          "Business enquiry records are retained for the period necessary to handle the enquiry and related business relationship, unless a longer legal retention period applies.",
          "Personal data is not sold. Data may be accessed by authorized staff and by technical service providers where necessary for operation, support, accounting, legal compliance, or IT security.",
        ],
      },
      {
        heading: "Your rights",
        body: [
          "You may request access, rectification, erasure, restriction of processing, data portability where applicable, and object to processing based on legitimate interest.",
          `Requests can be sent to ${company.privacyEmail}.`,
          "You may lodge a complaint with the Hungarian National Authority for Data Protection and Freedom of Information (NAIH).",
        ],
      },
      {
        heading: "Adatkezelő",
        body: [
          `Az adatkezelő: ${company.fullName} (${company.shortName}).`,
          `Székhely: ${company.registeredSeat}`,
          `Adatvédelmi kapcsolattartó: ${company.privacyEmail}`,
          "A társaság adatvédelmi tisztviselőt nem nevezett ki.",
        ],
      },
      {
        heading: "Nyilvános weboldal adatkezelése",
        body: [
          "A nyilvános PV-REPORT landing page célja a PV-REPORT platform bemutatása és kapcsolattartási lehetőség biztosítása demo- és üzleti megkeresésekhez.",
          "A weboldal technikai szervernapló adatokat kezelhet, például IP-címet, kérés időpontját, kért URL-t, böngésző user agentet, HTTP státuszkódot és hasonló biztonsági vagy diagnosztikai adatokat.",
          "A nyilvános landing page saját üzemeltetésű Umami analitikát is használ az aggregált látogatói aktivitás, oldalmegtekintések, hivatkozó oldalak, országok, eszközök, böngészők és demó kérés kattintások megértéséhez. Az Umami rendszert a T-NRG Kft. saját infrastruktúrán üzemelteti.",
          "Az adatkezelés jogalapja az adatkezelő jogos érdeke a biztonságos és megbízható weboldal-üzemeltetésben, valamint a szolgáltatás visszaélésekkel szembeni védelmében.",
        ],
      },
      {
        heading: "Kapcsolatfelvétel e-mailben vagy telefonon",
        body: [
          "Ha e-mailben vagy telefonon veszi fel a kapcsolatot a T-NRG Kft.-vel, a társaság kezeli az Ön által megadott személyes adatokat, például nevet, e-mail címet, telefonszámot, céget, üzenettartalmat és kapcsolódó üzleti kommunikációt.",
          "Az adatkezelés jogalapja szerződéskötést megelőző lépések megtétele, adott esetben szerződés teljesítése, illetve jogos érdek az üzleti megkeresések megválaszolásában.",
        ],
      },
      {
        heading: "Megőrzés és címzettek",
        body: [
          "A technikai szervernaplók csak a biztonsági, diagnosztikai és üzemeltetési hibaelhárításhoz szükséges ideig kerülnek megőrzésre.",
          "Az üzleti megkeresések adatai a megkeresés és az esetleges üzleti kapcsolat kezeléséhez szükséges ideig kerülnek megőrzésre, kivéve, ha jogszabály hosszabb megőrzést ír elő.",
          "A személyes adatokat a társaság nem értékesíti. Az adatokhoz jogosult munkatársak és szükség szerint műszaki szolgáltatók férhetnek hozzá üzemeltetés, támogatás, könyvelés, jogi megfelelés vagy IT-biztonság céljából.",
        ],
      },
      {
        heading: "Érintetti jogok",
        body: [
          "Ön kérheti a hozzáférést, helyesbítést, törlést, az adatkezelés korlátozását, adott esetben az adathordozhatóságot, és tiltakozhat a jogos érdeken alapuló adatkezelés ellen.",
          `Kérelmeit a ${company.privacyEmail} címen küldheti meg.`,
          "Panaszt tehet a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH).",
        ],
      },
    ],
  },
  cookies: {
    title: "Cookie Policy / Sütikezelési tájékoztató",
    updated: "Last updated / Utolsó frissítés: 2026-05-31",
    sections: [
      {
        heading: "Public landing page",
        body: [
          "The public PV-REPORT landing page uses self-hosted Umami analytics without analytics cookies, advertising cookies, tracking pixels, embedded third-party marketing tools, or cross-site tracking.",
          "Umami records aggregated website analytics and selected public landing page events, such as demo request clicks. It is not enabled for authenticated product usage analytics in this version.",
          "Because the public landing page does not use non-essential cookies, a cookie consent banner is not displayed.",
        ],
      },
      {
        heading: "Authenticated application",
        body: [
          "The authenticated PV-REPORT application may use technical authentication/session storage necessary for login, security, and application operation.",
          "These technical mechanisms are necessary to provide the logged-in service and are not used for advertising tracking.",
        ],
      },
      {
        heading: "Future analytics",
        body: [
          "If logged-in product analytics, advertising pixels, embedded third-party services, or cookie-based analytics are introduced later, this policy will be updated before activation. Where consent is required by applicable law, analytics will only be enabled after valid consent.",
        ],
      },
      {
        heading: "Nyilvános landing page",
        body: [
          "A nyilvános PV-REPORT landing page saját üzemeltetésű Umami analitikát használ analitikai sütik, reklámsütik, követőpixelek, beágyazott harmadik feles marketing eszközök és oldalak közötti követés nélkül.",
          "Az Umami aggregált weboldal-analitikát és kiválasztott nyilvános landing page eseményeket, például demó kérés kattintásokat rögzít. Ebben a verzióban nincs bekapcsolva bejelentkezett termékhasználati analitika.",
          "Mivel a nyilvános landing page nem használ nem feltétlenül szükséges sütiket, süti hozzájárulási banner nem jelenik meg.",
        ],
      },
      {
        heading: "Bejelentkezést igénylő alkalmazás",
        body: [
          "A bejelentkezést igénylő PV-REPORT alkalmazás technikai hitelesítési vagy munkamenet-tárolást használhat, amely a belépéshez, biztonsághoz és az alkalmazás működéséhez szükséges.",
          "Ezek a technikai megoldások a bejelentkezett szolgáltatás biztosításához szükségesek, és nem reklámcélú követést szolgálnak.",
        ],
      },
      {
        heading: "Jövőbeli analitika",
        body: [
          "Ha később bejelentkezett termékhasználati analitika, reklámpixel, beágyazott harmadik feles szolgáltatás vagy sütialapú analitika kerül bevezetésre, a tájékoztató az aktiválás előtt frissül. Ahol a jogszabály hozzájárulást ír elő, az analitika csak érvényes hozzájárulás után lesz bekapcsolva.",
        ],
      },
    ],
  },
};

export default function LegalPage({ type }) {
  const page = pages[type] || pages.imprint;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-950">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3 font-bold text-slate-950">
            <img src="/pvapplogo.png" alt="PV-REPORT logo" className="h-9 w-9 rounded" />
            PV-REPORT
          </Link>
          <Link className="text-sm font-semibold text-slate-700 hover:text-slate-950" to="/">
            Back to homepage
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <h1 className="text-3xl font-bold tracking-normal">{page.title}</h1>
          <p className="mt-2 text-sm text-slate-500">{page.updated}</p>
          <div className="mt-10 space-y-10">
            {page.sections.map((section) => (
              <section key={section.heading}>
                <h2 className="text-xl font-bold text-slate-950">{section.heading}</h2>
                <div className="mt-4 space-y-3 text-base leading-7 text-slate-700">
                  {section.body.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
